// extracted by mini-css-extract-plugin
export default {"container":"FreeDelivery_container__aKbMi","content":"FreeDelivery_content__fsvgu","title":"FreeDelivery_title__m1tVH","button":"FreeDelivery_button__Qlk7w"};